import dayjs from "dayjs";
import customParseFormat from "dayjs/plugin/customParseFormat";
import { get } from "svelte/store";
import {
  activeDateFormat,
  dayjsFormats,
  DateFormatType,
} from "../stores/globalProjectStore.js";

dayjs.extend(customParseFormat);

const INPUT_FORMAT = "YYYY/MM/DD HH:mm:ss";

function formatDateInternal(dateTimeStr, formatVariant) {
  if (!dateTimeStr) {
    return "";
  }

  const dateObj = dayjs(dateTimeStr, INPUT_FORMAT, true);

  if (!dateObj.isValid()) {
    console.warn(
      `[dateFormatter] Invalid date string provided: "${dateTimeStr}". Returning original.`
    );
    return dateTimeStr; // return original when failed
  }

  const currentFormatType = get(activeDateFormat);

  // If dayjsFormats not valid, use YMD
  const formatString = (dayjsFormats[currentFormatType] ||
    dayjsFormats[DateFormatType.YMD])[formatVariant];

  return dateObj.format(formatString);
}

/**
 * Datetime string ("YYYY/MM/DD HH:mm:ss") to localized datetime string
 * @param {string} dateTimeStr
 * @returns {string}
 */
export function formatDateTime(dateTimeStr) {
  return formatDateInternal(dateTimeStr, "dateTime");
}

/**
 * Datetime string ("YYYY/MM/DD HH:mm:ss") to localized date string
 * @param {string} dateTimeStr
 * @returns {string}
 */
export function formatDate(dateTimeStr) {
  return formatDateInternal(dateTimeStr, "date");
}

/**
 * Datetime string (like "250418-115005") to standard datetime string (like 2025/04/18 11:50:05, not localized!)
 * @param {string} dateTimeStr
 * @returns {string}
 */
export function deprecatedDateTimeString2DateTimeString(deprecatedDateTimeStr) {
  if (!deprecatedDateTimeStr || deprecatedDateTimeStr.length !== 13) {
    console.warn(
      `Invalid deprecated date string provided: "${deprecatedDateTimeStr}". Returning original.`
    );
    return deprecatedDateTimeStr;
  }

  const year = `20${deprecatedDateTimeStr.slice(0, 2)}`;
  const month = deprecatedDateTimeStr.slice(2, 4);
  const day = deprecatedDateTimeStr.slice(4, 6);
  const hour = deprecatedDateTimeStr.slice(7, 9);
  const minute = deprecatedDateTimeStr.slice(9, 11);
  const second = deprecatedDateTimeStr.slice(11, 13);

  return `${year}/${month}/${day} ${hour}:${minute}:${second}`;
}

/**
 * Date object to localized date time string
 * @param {Date} dateObject
 * @returns {string}
 */
export function formatDateTimeFromDate(dateObj) {
  if (!(dateObj instanceof Date) || isNaN(dateObj.getTime())) {
    console.warn(`[dateFormatter] Invalid Date object provided: ${dateObj}`);
    return "";
  }

  const dayjsObj = dayjs(dateObj);
  return formatDateInternal(dayjsObj.format(INPUT_FORMAT), "dateTime");
}

/**
 * Date object to localized date string
 * @param {Date} dateObject
 * @returns {string}
 */
export function formatDateFromDate(dateObj) {
  if (!(dateObj instanceof Date) || isNaN(dateObj.getTime())) {
    console.warn(`[dateFormatter] Invalid Date object provided: ${dateObj}`);
    return "";
  }

  const dayjsObj = dayjs(dateObj);
  return formatDateInternal(dayjsObj.format(INPUT_FORMAT), "date");
}
